import { Pencil, Trash2 } from "lucide-react";
import { CATEGORIES } from "@/lib/api";

const NewsItem = ({ n, onEdit, onRemove }) => (
  <div className="p-4 rounded-lg border border-white/5 bg-[#11141c] flex gap-4 justify-between" data-testid={`admin-news-${n.id}`}>
    <div className="min-w-0">
      <div className="text-[10px] tracking-widest text-amber-500/90">{CATEGORIES[n.category]} · {new Date(n.created_at).toLocaleDateString("pl-PL")}</div>
      <div className="font-semibold text-slate-100 mt-1">{n.title}</div>
      <div className="text-sm text-slate-500 line-clamp-2">{n.content}</div>
    </div>
    <div className="flex gap-3 shrink-0">
      <button onClick={() => onEdit(n)} className="text-slate-500 hover:text-amber-300" data-testid={`news-edit-${n.id}`}><Pencil size={15} /></button>
      <button onClick={() => onRemove(n.id)} className="text-slate-500 hover:text-red-400" data-testid={`news-delete-${n.id}`}><Trash2 size={15} /></button>
    </div>
  </div>
);

export default function NewsList({ news, onEdit, onRemove }) {
  return (
    <div className="space-y-3" data-testid="admin-news-list">
      {news.map((n) => <NewsItem key={n.id} n={n} onEdit={onEdit} onRemove={onRemove} />)}
      {!news.length && <p className="text-slate-600 text-sm">Brak wpisów.</p>}
    </div>
  );
}
